import { AnimationBaseController, IAnimationControllerConfiguration, Inject } from '@denishussar/html5-game-engine';
import { GameModel, RoadObjectType } from '../../Models/GameModel';
import { AnimationContents } from '../../../AnimationContents';
import { GameLogic } from '../../Logic/GameLogic';
import { remapValue } from '../../Common/Utils';
import { GameObstacleProjectionController } from './obstacles/static/GameObstacleProjectionController';
import { Point, projection } from 'pixi.js';
import { roadLength } from './GameScreenController';
import { thousandSpacing } from '../../Utils/StringRework';

export interface IGameGasStationControllerOptions {
    index: number;
    projection: GameObstacleProjectionController;
}

export class GameGasStationController extends AnimationBaseController {
    $model: GameModel;
    public applied = false;
    private _projectionScale: number[] = [0.3, 12.8];
    private aspect = 1;
    private _index: number = 0;

    public constructor(
        @Inject public options: IGameGasStationControllerOptions,
        @Inject private _gameLogic: GameLogic,
    ) {
        super('GameGasStationController');
    }
    // 16:9 0.25 
    // 915/400 0.28
    protected getConfiguration(): IAnimationControllerConfiguration {
        return <IAnimationControllerConfiguration>{
            animationContent: AnimationContents.GAME_SCREEN_JSON,
            libraryName: 'gas_station',
        };
    }

    protected onInitialize(): void {
        this.display["controller"] = this;
        this._index = this.options.index;
        this.gotoAndStop(this.$model.currentLevel - 1);
    }

    protected onResize(width: number, height: number, scale: number) {
        this.aspect = height / width;
    }
    public getObjectType(): RoadObjectType {
        return RoadObjectType.gasStation;
    }

    protected onUpdate(frameRate: number) {
        // const globalPoint = this.display.parent.toGlobal(this.display.position);

        // this.display.scale.set(remapValue(globalPoint.y,
        //     this.renderer.renderer.height * 0.25, this.renderer.renderer.height,
        //     this._projectionScale[0] * GameModel.SCALE, this._projectionScale[1] * GameModel.SCALE,
        // ));

        if (!this.options.projection) return;
        const globalProjectionPoint = this.options.projection.display.parent.toGlobal(this.options.projection.display.position);
        const localPoint = this.display.parent.toLocal(globalProjectionPoint, this.renderer.stage);

        // let scale = remapValue(globalProjectionPoint.y,
        //     this.renderer.renderer.height * (0.042718446602*this.aspect + 0.182281553398), this.renderer.renderer.height,
        //     (0.2*this.aspect-0.1) * GameModel.SCALE, (1.8*this.aspect+9.2) * GameModel.SCALE,
        // );
        this.options.projection.display.x = this.$model.gameScreen._roadTexture.width / 2 / GameModel.SCALE;
        const right = (this.options.projection.display as projection.Container3d).toGlobal(localPoint);
        this.options.projection.display.x = -this.$model.gameScreen._roadTexture.width / 2 / GameModel.SCALE;
        const left = (this.options.projection.display as projection.Container3d).toGlobal(localPoint);
        // console.log(right.x - left.x);
        this.options.projection.display.x = 0;
        let scale = (right.x - left.x) / this.width * 2.8 * (this.renderer.renderer.screen.height / this.renderer.renderer.screen.width) //*this.aspect;
        // let scale = remapValue((this.options.projection.display as projection.Container3d).y, 0, roadLength, (959-660)/1308,(975+804)/1308);
        // console.log((this.options.projection.display as projection.Container3d).y)
        this.display.x = localPoint.x;
        this.display.y = localPoint.y;
        this.display.scale.set(scale, scale);

        if (this.options.projection)
            this.alpha = Math.min(1, this.options.projection.display.y / 500);

    }

    public getIndex(): number {
        return this._index;
    }

    public getType() {
        return "gas"
    }

}
